/**
 * Keep an authorized token change in this document when its room/config URL
 * is otherwise identical (a consumed moveCall flag aside). A different room, tenant, query or fragment still
 * needs the normal navigation so its config.js can be loaded.
 *
 * @param {URL} authorizedURL - The URL returned by room authorization.
 * @returns {boolean} Whether the current document URL was updated.
 */
export function replaceRoomTokenInCurrentURL(authorizedURL) {
    const current = new URL(window.location.href);
    const authorized = new URL(authorizedURL.href);
    if (!authorized.searchParams.get('jwt') || authorized.href === current.href) {
        return false;
    }
    current.searchParams.delete('jwt');
    authorized.searchParams.delete('jwt');
    // "Move call here" arrives as moveCall=1, which the room-token mint
    // consumes; the page URL keeps the room without it.
    current.searchParams.delete('moveCall');
    if (current.href !== authorized.href) {
        return false;
    }
    try {
        window.history.replaceState(window.history.state, '', authorizedURL.href);
        return true;
    }
    catch {
        // Restricted embeds can reject history access. Normal navigation
        // remains available with the server-authorized URL in Redux.
        return false;
    }
}
